import React from 'react'

const ReportEarthingTesting = () => {
  return (
    <div>
      ReportEarthingTesting
    </div>
  )
}

export default ReportEarthingTesting
